import { Image } from "@chakra-ui/react";
import { NFTEvent, NFTEventInfo } from "@models/event";
import { DEFAULT_LANGUAGE } from "@models/language";
import { useMemo } from "react";
import { PaymentStep, usePaymentStore } from "../../payment";
import CheckoutOrderSummary from "../CheckoutOrderSummary/CheckoutOrderSummary";
import CheckoutButton from "../CheckoutToolbar/CheckoutButton";

const CheckoutSidebar = ({
  event,
  allowSubmit,
}: {
  event: NFTEvent;
  allowSubmit: boolean;
}) => {
  const language = DEFAULT_LANGUAGE;
  const info: NFTEventInfo = useMemo(() => {
    if (!event) return new NFTEventInfo({ name: "" });
    return event.localeInfo(language);
  }, [event, language]);
  const currentStep = usePaymentStore((state) => state.currentStep);

  return (
    <div className="flex-shrink-0 sm:w-[22rem] flex flex-col max-full h-auto sm:min-h-full border-neutral-100 dark:border-neutral-700 dark:bg-white/[.05] bg-white/[.6] rounded-lg sm:shadow-xl overflow-hidden my-1">
      <div className="hidden sm:flex flex-col flex-shrink-0 h-auto min-h-0">
        {/* <p className="text-center dark:text-neutral-10 text-xl font-medium px-4 mb-8"> */}
        {/*   {info.name} */}
        {/* </p> */}
        <Image
          className="max-h-96"
          objectFit="cover"
          src={
            info.hero ||
            info.banner ||
            (info.gallery && info.gallery.length > 0
              ? info.gallery[0]
              : "/images/event-placeholder.svg")
          }
          alt={info.name}
        />
      </div>

      {event.isERC1155BulkPurchase &&
      currentStep === PaymentStep.SELECT_ITEMS ? (
        <div className="h-8"></div>
      ) : (
        <CheckoutOrderSummary />
      )}
      <div className="hidden sm:flex flex-col items-stretch">
        <CheckoutButton allowSubmit={allowSubmit} />
      </div>
    </div>
  );
};

export default CheckoutSidebar;
